export default __webpack_public_path__ + "static/media/startupRealCase1-mobile.1baea095.jpg";